import script from "./FormularioView.vue?vue&type=script&setup=true&lang=js"
export * from "./FormularioView.vue?vue&type=script&setup=true&lang=js"

import "./FormularioView.vue?vue&type=style&index=0&id=4e9f2f1c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4e9f2f1c"]])

export default __exports__